
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.47 11.883l3.766-3.738a.625.625 0 00-.44-1.07H8.25V.723a.625.625 0 00-.625-.625h-1.25a.625.625 0 00-.625.625v6.354H3.204a.625.625 0 00-.44 1.069l3.767 3.738c.26.258.68.258.939 0zM0 14.163a1 1 0 011-1h12a1 1 0 011 1v.673a1 1 0 01-1 1H1a1 1 0 01-1-1v-.673z","fill":"#525F7F"}})])
          )
        }
      }
    